var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIngreBin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 24,
    viewBox: "0 0 19 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.125 0L5.9375 1.2H0V3.6H19V1.2H13.0625L11.875 0H7.125ZM1.1875 6V21.6C1.1875 22.92 2.25625 24 3.5625 24H15.4375C16.7437 24 17.8125 22.92 17.8125 21.6V6H1.1875ZM4.75 8.4H7.125V21.6H4.75V8.4ZM11.875 8.4H14.25V21.6H11.875V8.4Z",
    fill: "#40506A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIngreBin);
export default __webpack_public_path__ + "static/media/IngreBin.f600d3365f9c4ea5a24021b89344e739.svg";
export { ForwardRef as ReactComponent };